// Development(Staging), QA, Production
export const authRequestBQS: any = {
    scopes: ["api://051cbdd1-99b0-43e4-958e-1184ab1d44a2/readwrite"],
};

export const authRequestCQS: any = {
    scopes: ["api://e767e321-39af-473e-8b13-936cde7b20ac/readwrite"],
};

export const authRequestBc: any = {
    scopes: ["https://api.businesscentral.dynamics.com/user_impersonation"]
};
export const configurationBQS: any = {

    auth: {
        clientId: "233a263e-e9bb-4e52-a099-c2b2da0a86f3",
        authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        redirectUri: "https://bqstest.brentmaterial.com/",
        postLogoutRedirectUri: "https://bqstest.brentmaterial.com/",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};

export const configurationCQS: any = {

    auth: {
        clientId: "233a263e-e9bb-4e52-a099-c2b2da0a86f3",
        authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        redirectUri: "https://cqstest.brentmaterial.com/",
        postLogoutRedirectUri: "https://cqstest.brentmaterial.com/",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};



// WEBPACK FOOTER //
// ./ClientApp/config.staging.ts